export function setButtonSpinnerState(button, isActive) {
    if (isActive) {
        button.classList.remove("disabled");
        button.removeChild(document.getElementById('spinner'));
    }
    else {
        button.className += " disabled";
        button.innerHTML += "<span class='spinner-grow spinner-grow-sm' id='spinner' role='status' aria-hidden='true'></span>";
    }
}
